export default __webpack_public_path__ + "static/media/edit.84f0f1cb.svg";